import secondLogo from '@/assets/docs_second_logo@300px.gif';
import docsSpecial from '@/assets/docs_special@240px.jpg';
import styles from './HomePage.module.css';

// Gallery images bundled as local assets
const galleryImages = Object.values(
  import.meta.glob('@/assets/gallery/*.jpg', { eager: true, query: '?url', import: 'default' })
) as string[];

function HomePage() {
  return (
    <div className={styles.page}>
      {/* Hero section */}
      <section className={styles.hero}>
        <img src={secondLogo} alt="Dr. Davis Ice Cream logo" className={styles.heroLogo} />
        <h1 className={styles.heroTitle}>Making and serving our own ice cream for over 80 years!</h1>
        <h2 className={styles.heroSubtitle}>Home of the Doc's Special</h2>
        <div className={styles.specialPhoto}>
          <img src={docsSpecial} alt="Doc's Special Sundae" className={styles.specialImage} />
        </div>
      </section>

      {/* Main info section */}
      <section className={styles.info}>
        <h1 className={styles.infoTitle}>Doc's Pepperell</h1>
        <h2 className={styles.infoAddress}>67 Hollis Street<br />Pepperell MA, 01463</h2>
        <h3 className={styles.infoStatus}>Open for the season!</h3>
        <h3 className={styles.infoStatus}>Open daily 12 to 9PM</h3>

        {/* Photo gallery */}
        <div className={styles.gallery}>
          {galleryImages.map((src, i) => (
            <div key={i} className={styles.galleryItem}>
              <img src={src} alt="Dr. Davis Ice Cream" className={styles.galleryImage} />
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

export default HomePage;
